export default {
      id: "arrow-usage",
      viewBox: "0 0 11 19",
      url: "/assets/" + "icons.svg#arrow",
      toString: function () {
        return this.url;
      }
    }